module.exports = "https://www.gc-pro.gnp.com.mx/dea9b487633f9d55849d4b4c4420951d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/portalluli.png
// module id = 8159
// module chunks = 0